import * as React from "react";
import { useState, useEffect } from "react";
import { selTodasReferencias } from "../../../utils/functions";
import Row from "./RowProdutosMarketplace";
import "./TabelaProdutosMarketplace.css";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import CardOffer from "../../../components/gestao/CardOffer/CardOffer";
import { Pagination } from "@mui/material";

// detalhesProduto: na tela da OFF mostra a grife e a descrição do produto do ERP. Só as linhas
// da RESERVA têm esses campos: as colunas aparecem quando há linha da RESERVA na tabela
export default function TabelaProdutosMarketplace({ rows, tipo_tabela, detalhesProduto: telaOff }) {
  const [dados, setDados] = useState([]);
  const [ordenacao, setOrdenacao] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const detalhesProduto = telaOff && (rows || []).some(r => r.MARCA === "RESERVA");

  // A página começa em 1 (Pagination do MUI): a página N mostra as linhas
  // (N-1)*rowsPerPage até N*rowsPerPage. Antes o corte usava N*rowsPerPage e a
  // contagem arredondava para baixo, então as 100 primeiras linhas (e a última
  // página incompleta) nunca apareciam quando havia mais de 99 linhas.
  let pageCount = Math.ceil(dados.length / rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Sincroniza com a prop sempre que ela muda, e nao so na montagem: os
  // filtros da tela (marca, colecao, status de lancamento) refazem a
  // requisicao e passam um `rows` novo, que precisa substituir o anterior.
  // Volta para a primeira pagina porque o resultado filtrado pode ter menos
  // paginas do que a que estava aberta.
  useEffect(() => {
    setDados(rows || []);
    setPage(1);
  }, [rows]);

  const sort = () => {
    let dadosOrdenados = dados.sort(function (a, b) {
      let valorA = a.ESTOQUE * a.PRECO_ECOMMERCE;
      let valorB = b.ESTOQUE * b.PRECO_ECOMMERCE;
      return ordenacao ? valorA - valorB : valorB - valorA;
    });
    setOrdenacao(ordenacao ? false : true);
    setDados(dadosOrdenados);
  };

  return (
    <div className="tabela-responsiva-marketplace">
      <table className="table-border" cellspacing="0">
        <thead>
          <tr className="header-tabela">
            {tipo_tabela && (
              <th className="">
                <label className="custom-checkbox checkbox-mobile" style={{ width: "120px" }}>
                  <input
                    type="checkbox"
                    id="checkboxTodasReferencias"
                    onClick={(e) => {
                      selTodasReferencias(e, "checkboxMarketplace", "refSelecionadasMarketplace", "btn_aprovar_marketplace");
                    }}
                  />
                  <span className="checkmark">Referência</span>
                </label>
              </th>
            )}

            {!tipo_tabela && <th className="p-l-20">Referência </th>}
            {detalhesProduto && <th>Grife</th>}
            {detalhesProduto && <th>Descrição</th>}
            <th>Qtd de SKU</th>
            <th>Coleção</th>
            <th>
              {" "}
              <div className="valor-estoque">
                {" "}
                Valor em estoque{" "}
                <button className="sort" onClick={sort}>
                  {" "}
                  {ordenacao ? <ExpandLess /> : <ExpandMore />}{" "}
                </button>{" "}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {!rows ? (
            <Skeleton className="skeleton-format skeleton-nao-ofertados" variant="rectangular" />
          ) : (
            <>
              <CardOffer id={tipo_tabela ? "cardOfferPendentes" : false} texto={"Não há referências pendentes de aprovação"} />
              {dados.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((iten) => {
                return <Row row={iten} detalhesProduto={detalhesProduto} />;
              })}
            </>
          )}
        </tbody>
      </table>

      <div className="wrapper-pagination">
        <Pagination
          shape="rounded"
          color="primary"
          count={pageCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
}
